// extracted by mini-css-extract-plugin
export default {"records":"DetailContainer_records__X67MM"};